import UnitQuizSkillResult from './model';
import create from './create';

UnitQuizSkillResult.create = create;

export default UnitQuizSkillResult;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/UnitQuizResult/UnitQuizSkillResult/index.js